/**
 * Modnium Interactions
 * Scroll-reveal animations, smooth hover, subtle premium polish
 */

(function () {
  'use strict';

  // === SCROLL REVEAL ===
  // Subtle fade-up on key sections as they enter viewport
  function initScrollReveal() {
    const candidates = document.querySelectorAll([
      'section.modnium-collections-grid',
      '.section--modnium-room-grid',
      '[id^="shopify-section-"] > section',
      '[id^="shopify-section-"] > div > section',
      'product-list',
      'product-recommendations',
      '.modnium-collection-card',
    ].join(','));

    if (!('IntersectionObserver' in window) || candidates.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('modnium-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -8% 0px',
    });

    candidates.forEach((el) => {
      el.classList.add('modnium-reveal-active');
      observer.observe(el);
    });
  }

  // === STAGGERED REVEAL for grid items ===
  function initStaggeredReveal() {
    const grids = document.querySelectorAll([
      '.modnium-collections-grid__cards',
      '.product-grid',
      '.product-recommendations__grid',
    ].join(','));

    grids.forEach((grid) => {
      const items = grid.children;
      Array.from(items).forEach((item, i) => {
        item.style.setProperty('--modnium-reveal-delay', `${i * 80}ms`);
      });
    });
  }

  // === HEADER scroll behavior ===
  // Compact header on scroll
  function initHeaderScroll() {
    const header = document.querySelector('#header-component, header-component, .header-section');
    if (!header) return;

    let lastScroll = 0;
    let ticking = false;

    function onScroll() {
      const currentScroll = window.scrollY;

      if (currentScroll > 80) {
        header.classList.add('modnium-header-scrolled');
      } else {
        header.classList.remove('modnium-header-scrolled');
      }

      lastScroll = currentScroll;
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });
  }

  // === SMOOTH ANCHOR scrolling (for "Read More" etc.) ===
  function initSmoothAnchor() {
    document.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (e) => {
        const target = document.querySelector(link.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  // === ANNOUNCEMENT BAR — pause on hover (extra safety) ===
  function initAnnouncementHover() {
    const bar = document.querySelector('.modnium-announcement-bar');
    if (!bar) return;
    const track = bar.querySelector('.modnium-announcement-track');
    if (!track) return;

    bar.addEventListener('mouseenter', () => {
      track.style.animationPlayState = 'paused';
    });
    bar.addEventListener('mouseleave', () => {
      track.style.animationPlayState = 'running';
    });
  }

  // === PRODUCT CARD — preload hover image ===
  function initProductCardPreload() {
    const cards = document.querySelectorAll('product-card, .product-card');
    cards.forEach((card) => {
      card.addEventListener('mouseenter', () => {
        const allImages = card.querySelectorAll('img');
        if (allImages.length > 1) {
          // Trigger lazy load for any non-first images
          allImages.forEach((img) => {
            if (img.loading === 'lazy' && !img.complete) {
              img.loading = 'eager';
            }
          });
        }
      }, { once: false });
    });
  }

  // === BACK TO TOP — show/hide on scroll ===
  function initBackToTop() {
    const btn = document.querySelector('.modnium-back-top');
    if (!btn) return;

    let ticking = false;
    function onScroll() {
      if (window.scrollY > 600) {
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
      }
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });
  }

  // === INIT all ===
  function init() {
    // Scroll reveal disabled — was potentially hiding content if not triggered
    // initScrollReveal();
    // initStaggeredReveal();
    initHeaderScroll();
    initSmoothAnchor();
    initAnnouncementHover();
    initProductCardPreload();
    initBackToTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', init);
})();
